/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { CartLine, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { observable } from 'mobx';

/**
 * Represents a product for quick order.
 */
export class QuickOrderProduct {
    @observable
    public isSelected: boolean;

    public readonly cartLine: CartLine;

    public readonly simpleProduct: SimpleProduct;

    public constructor(cartLine: CartLine, simpleProduct: SimpleProduct) {
        this.cartLine = cartLine;
        this.simpleProduct = simpleProduct;
        this.isSelected = false;
    }
}
